import { render, staticRenderFns } from "./AdminDatosEmpresaFormulario.vue?vue&type=template&id=2766ca30&"
import script from "./AdminDatosEmpresaFormulario.vue?vue&type=script&lang=ts&"
export * from "./AdminDatosEmpresaFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports